import { useEffect } from 'react';

/**
 * Set the document title and <meta name="description"> for the current page.
 * Restores the previous values on unmount so cross-navigation stays clean.
 *
 * Usage inside a page component:
 *   usePageMeta({
 *     title: 'Login — Epicurea Nexus',
 *     description: 'Sign in to your Epicurea Nexus account.',
 *   });
 */
export function usePageMeta({ title, description }) {
  useEffect(() => {
    const prevTitle = document.title;

    let metaEl = document.querySelector('meta[name="description"]');
    const prevDesc = metaEl ? metaEl.getAttribute('content') : null;
    const createdMeta = !metaEl;
    if (!metaEl) {
      metaEl = document.createElement('meta');
      metaEl.setAttribute('name', 'description');
      document.head.appendChild(metaEl);
    }

    if (title) document.title = title;
    if (description) metaEl.setAttribute('content', description);

    return () => {
      document.title = prevTitle;
      if (createdMeta) {
        metaEl.remove();
      } else if (prevDesc !== null) {
        metaEl.setAttribute('content', prevDesc);
      }
    };
  }, [title, description]);
}

export default usePageMeta;
